module.exports = __webpack_public_path__ + "img/preview.0bee9ee0.jpg";